"use client";

import FallBackImage from "@/components/FallBackImage/FallBackImage";
import {
  categoriesAtom,
  selectedStoreAtom,
  storeLocationsAtom,
} from "@webelocity/state";
import { Skeleton } from "@mui/material";
import { useAtomValue } from "jotai";
import Image from "next/image";
import { useRouter } from "next/navigation";
import "./Categories.scss";
import { Category } from "@webelocity/core";

const Categories = () => {
  const router = useRouter();
  const categories = (useAtomValue(categoriesAtom) as Category[]) ?? [];
  const selectedStore = useAtomValue(selectedStoreAtom);
  const storeLocations = useAtomValue(storeLocationsAtom);
  // console.log("categories", categories);
  // console.log("selectedStore", selectedStore);
  // console.log("storeLocations", storeLocations);
  const categories_status = categories.length > 0 ? "succeeded" : "loading";

  // Jotai handles loading automatically using Suspense, but we'll mock status for now
  // console.log("categories_status", categories_status);

  const handleCategoryClick = (categoryId: string) => {
    router.push(`/shop/catalogue?cat=${categoryId}`);
  };

  return (
    <div className='home-categories-wrapper baseContainer'>
      <div className='maxWidth'>
        <div className='header-wrapper'>
          {categories_status === "loading" ? (
            <>
              <Skeleton
                variant='text'
                width={220}
                height={36}
                sx={{ flexShrink: 0 }}
              />
              <Skeleton
                variant='rounded'
                width={140}
                height={44}
                sx={{ borderRadius: 2 }}
              />
            </>
          ) : (
            <>
              <h3 className='section-main-header blue-500'>
                Featured Categories
              </h3>
              <button
                className='main-btn'
                onClick={() => {
                  router.push("/shop/catalogue");
                }}>
                Explore More
              </button>
            </>
          )}
        </div>

        <div className='categories-section'>
          {categories_status === "loading"
            ? Array.from({ length: 20 }).map((_, i) => (
                <div key={i} className='category-item'>
                  <Skeleton
                    variant='rounded'
                    width={120}
                    height={120}
                    sx={{ borderRadius: "25%" }}
                  />
                  <Skeleton
                    variant='text'
                    width={80}
                    height={24}
                    sx={{ marginInline: "auto" }}
                  />
                </div>
              ))
            : categories.map((category) => (
                <div
                  onClick={() => handleCategoryClick(category._id)}
                  key={category._id}
                  className='category-item'>
                  <div className='image-wrapper'>
                    {category?.image ? (
                      <Image fill src={category?.image ?? ""} alt='lumber' />
                    ) : (
                      <FallBackImage />
                    )}
                  </div>
                  <p className='text-medium-24 black weight-600'>
                    {category?.name}
                  </p>
                </div>
              ))}
        </div>

        <button
          className='main-btn mobile'
          onClick={() => {
            router.push("/shop/catalogue");
          }}>
          Explore More
        </button>
      </div>
    </div>
  );
};

export default Categories;
